import axios from '@/utils/request';

// 获取车辆预警列表数据
export const getList = (params) => {
    return axios.get('/system/warn/getCarWarnList', {params})
}

// 获取车辆预警详情
export const getDetail = (params) => {
    return axios.get('/system/warn/getCarWarnInfo', {params})
}